var a={send:function(a){"undefined"!=typeof window&&window.dataLayer&&window.dataLayer.push(a)}};export{a as T};
